import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Link, Routes, useNavigate } from "react-router-dom";


import {
  LaptopOutlined,
  NotificationOutlined,
  UserOutlined,
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingTwoTone,
  HomeTwoTone,
  UsergroupAddOutlined,
  EnvironmentTwoTone,
  ToolTwoTone,
  ShopTwoTone,
  ArrowRightOutlined,
  ContainerTwoTone,
  BuildTwoTone,
  HddTwoTone,
  EyeInvisibleTwoTone,
  ShoppingTwoTone,
  CreditCardOutlined,
  CreditCardTwoTone,
  BookTwoTone,
  CloudTwoTone,
  SafetyCertificateTwoTone,
  PercentageOutlined,
  GiftOutlined
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import {
  Breadcrumb,
  Layout,
  Menu,
  theme,
  Button,
  Space,
  Checkbox,
  Form,
  Input,
  Grid
} from "antd";
import { Auth } from 'aws-amplify';

const { useBreakpoint } = Grid;

//// Menu Props for ant.dd
type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group"
): MenuItem {
    // Check if the label is a string and wrap it with a <Link>
    let wrappedLabel = label;

      // Convert key to string for use in the Link component
      const keyStr = key.toString();

    // Check if the label is a string and does not start with "sub"
    if (typeof label === 'string' && !keyStr.startsWith("/sub")) {
      wrappedLabel = <Link to={key.toString()}>{label}</Link>;
    }

  return {
    key,
    icon,
    children,
    label: wrappedLabel,
    type,
  } as MenuItem;
}

function getWrappedItem(label: string, key: React.Key): MenuItem {
  return {
    ...getItem(label, key),
    style: {
      height: "auto",
      minHeight: 40,
      lineHeight: "20px",
      paddingTop: 10,
      paddingBottom: 10,
      whiteSpace: "normal",
    },
  } as MenuItem;
}

const items: MenuItem[] = [
  getItem("Home", "/home-admin", <HomeTwoTone />, [
    getItem("Announcements", "/announcements"),
  ]),

  getItem("Sales", "/sub-sales", <CreditCardTwoTone />, [
    getItem("Revenue Dashboard (PH)", "/sales/revenue"),
    getWrappedItem("Revenue Dashboard (SIMPLY Web)", "/sales/revenue/simply-web"),
    getItem("Settings", "/sales/revenue/settings"),
  ]),

  getItem('eSIM', '/sub1', <EnvironmentTwoTone />, [

      getItem("Order Submit", "/redemption/manual"),
      getItem("Manage Orders", "/redemption/"),
      getItem("Slowboat Passports", "/slowboat/passports"),


      getItem("Inventory", "/sub6", <ContainerTwoTone />, [
        getItem("Manage", "/inventory/"),
        getItem("Upload", "/inventory/upload"),
        getItem("Mark as Inactive", "/inventory/deprecate")
      ]),
      getItem("Mappings", "/sub8", <BuildTwoTone />, [
        getItem("Manage", "/datamapping/"),
        getItem("Upload", "/datamapping/upload"),
        getItem("Joy-TGT", "/datamapping/joy-tgt")
      ]),
      // {
      //   key: 'sub1-6',
      //   label: 'Mappings (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/datamapping/"),
      //     getItem("Upload", "/datamapping/upload")
      //   ]
      // },
      // {
      //   key: 'sub1-6-1',
      //   label: 'Webshop (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/product-groups"),
      //     getItem("Upload", "/product-groups/upload")
      //   ]
      // },
      // {
      //   key: "sub1-7",
      //   label: 'Inventory (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/inventory/"),
      //     getItem("Upload", "/inventory/upload")
      //   ]
      // },
      // {
      //   key: "sub1-8",
      //   label: 'Redemption (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/redemption/"),
      //     getItem("Manual Submit", "/redemption/manual")
      //   ]
      // },
      // {
      //   key: 'sub1-3',
      //   label: 'TGT',
      //   children: [
      //     // getItem("Order Submit", "/jy-submit"),
      //     // getItem("Order History", "/jy-history"),
      //     // getItem("Redemption History", "/rd-history"),
      //     // getItem("Manual Callback", "/manual-cb"),
      //   ],
      // },
      // {
      //   key: 'sub1-4',
      //   label: 'Simply',
      //   children: [
      //     // getItem("Order Submit", "/jy-submit"),
      //     // getItem("Order History", "/jy-history"),
      //     // getItem("Redemption History", "/rd-history"),
      //     // getItem("Manual Callback", "/manual-cb"),
      //   ],
      // },
  ]),
  getItem("uSIM", "/sub7", <EnvironmentTwoTone />, [

    getItem("Orders", "/sub75", <ShoppingTwoTone />, [
      getItem("New Orders", "/psim/orders/new"),
      getItem("Manage Orders", "/psim/orders/manage"),
    ]),
    getItem("Activation", "/sub76", <EnvironmentTwoTone />, [
      getItem("Pending Activation", "/psim/activation/pending"),
      getItem("Activation Report ", "/psim/activation/report"),
    ]),
    getItem("Inventory", "/sub74", <EnvironmentTwoTone />, [
      getItem("Manage", "/psim/inventory"),
      getItem("Report", "/psim/inventory/report"),
      getItem("Inventory Upload", "/psim/uploads/inventory"),
      getItem("Uploads","/sub75", <CloudTwoTone  />, [
        getItem("Product Type Upload", "/psim/uploads/product-types"),
        getItem("Product Plan Upload", "/psim/uploads/product-plans"),

      ]),
        getItem("Usim-Mappings", "/sub81", <BuildTwoTone />, [
        getItem("Manage", "/psim/mappings/"),
        getItem("Upload", "/psim/mappings/upload")
      ]),
    ]),
  ]),
  getItem("Webshop/App", "/sub9", <ShoppingTwoTone />, [
    // getItem("Manage Products", "/product-groups"),
    // getItem("Upload Products", "/product-groups/upload"),
    getItem("Webshop Products", "/webshop/products"),
        getItem("Promotions", "/sub91", <GiftOutlined/>, [
      getItem("Discounts", "/webshop/promotions"),
    getItem("Bundle Deals", "/webshop/bundles"),
    getItem("Deal Redemptions", "/webshop/redemptions"),
    getItem("Usage Triggered Offers", "/webshop/usage-triggered-offers"),
    ]),

    getItem("Razorpay Orders", "/webshop/orders"),
    getItem("Website Users", "/webshop/users"),
  
    getItem("Webshop Images (Beta)", "/webshop/assets")
  ]),

  getItem("Distributor Portal", "/sub10", <ShopTwoTone />, [
    getItem("Distributors", "/distributor-portal"),
    getItem("eSIM Stock", "/distributor-portal/inventory"),
  ]),

  getItem("Archive", "/sub2", <EyeInvisibleTwoTone />, [
    {
      key: 'sub1-2',
      label: 'Joytel',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("Order Submit", "/jy-submit"),
        getItem("Order History", "/jy-history"),
        getItem("Redemption History", "/rd-history"),
        getItem("Manual Callback", "/manual-cb"),
        getItem("Update Mapping", "/u-mapping"),
      ],
    },
    {
      key: 'sub1-4',
      label: 'Slowboat',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("Order Submit", "/sb-submit"),
        getItem("Update Inventory", "/sb-mapping"),
        getItem("Inventory", "/sb-inventory"),
        getItem("Redemptions", "/sb-redemptions"),
      ]
    },
    {
      key: 'sub1-5',
      label: 'Mobifone',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("Order Submit", "/vn-submit"),
        getItem("Update Inventory", "/vn-mapping"),
        getItem("Inventory", "/vn-inventory"),
        getItem("Redemptions", "/vn-redemptions"),
      ]
    },
    {
      key: 'sub1-3',
      label: 'EliteMobile',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("SIM Topup", "/em-recharge"),
        getItem("Top Up Report", "/em-recharge-history")
      ]
    },
  ]),
  getItem('Platforms', '/sub3', <ShopTwoTone />, [
    getItem("Shopee Orders", "/shopee-view-orders"),
    getItem("Export Orders", "/platforms/export-orders"),
  ]),
  getItem('User Settings', '/sub4', <ToolTwoTone />, [
    getItem("Account Management", "/user-settings/accounts"),
    getItem("Add New User", "/u-add"),
    getItem("Activity Log", "/u-history"),
  ]),
  getItem('Admin Settings', '/sub5', <SettingTwoTone />, [
    getItem('Order Query', '/testapi', <AppstoreOutlined />),
    getItem("Joytel Test", "/jy-submit-test", <AppstoreOutlined />),
  ]),



]

const itemsUser: MenuItem[] = [
  getItem("Home", "/", <HomeTwoTone />, [
    getItem("Announcements", "/announcements"),
  ]),
  getItem("Sales", "/sub-sales", <CreditCardTwoTone />, [
    getItem("Revenue Dashboard (PH)", "/sales/revenue"),
    getWrappedItem("Revenue Dashboard (SIMPLY Web)", "/sales/revenue/simply-web"),
  ]),
  getItem('eSIM', '/sub1', <EnvironmentTwoTone />, [

      getItem("Order Submit", "/redemption/manual"),
      getItem("Manage Orders", "/redemption/"),

      getItem("Inventory", "/sub4", <ContainerTwoTone />, [
        getItem("Manage", "/inventory/"),
        getItem("Upload", "/inventory/upload"),
        getItem("Mark as Inactive", "/inventory/deprecate")
      ]),
      getItem("Mappings", "/sub3", <BuildTwoTone />, [
        getItem("Manage", "/datamapping/"),
        getItem("Upload", "/datamapping/upload"),
        getItem("Joy-TGT", "/datamapping/joy-tgt")
      ]),
      // {
      //   key: 'sub1-6',
      //   label: 'Mappings (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/datamapping/"),
      //     getItem("Upload", "/datamapping/upload")
      //   ]
      // },
      // {
      //   key: 'sub1-6-1',
      //   label: 'Webshop (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/product-groups"),
      //     getItem("Upload", "/product-groups/upload")
      //   ]
      // },
      // {
      //   key: "sub1-7",
      //   label: 'Inventory (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/inventory/"),
      //     getItem("Upload", "/inventory/upload")
      //   ]
      // },
      // {
      //   key: "sub1-8",
      //   label: 'Redemption (V2)',
      //   icon: <ArrowRightOutlined />,
      //   children: [
      //     getItem("Manage", "/redemption/"),
      //     getItem("Manual Submit", "/redemption/manual")
      //   ]
      // },
      // {
      //   key: 'sub1-3',
      //   label: 'TGT',
      //   children: [
      //     // getItem("Order Submit", "/jy-submit"),
      //     // getItem("Order History", "/jy-history"),
      //     // getItem("Redemption History", "/rd-history"),
      //     // getItem("Manual Callback", "/manual-cb"),
      //   ],
      // },
      // {
      //   key: 'sub1-4',
      //   label: 'Simply',
      //   children: [
      //     // getItem("Order Submit", "/jy-submit"),
      //     // getItem("Order History", "/jy-history"),
      //     // getItem("Redemption History", "/rd-history"),
      //     // getItem("Manual Callback", "/manual-cb"),
      //   ],
      // },
  ]),
  // Physical sim sidebar
  getItem("uSIM", "/sub7", <CreditCardTwoTone />, [
    getItem("Orders","/sub71", <ShoppingTwoTone />, [
      getItem("New Orders", "/psim/orders/new"),
      getItem("Manage Orders", "/psim/orders/manage"),
    ]),
    getItem("Activation","/sub72", <SafetyCertificateTwoTone />, [
      getItem("Pending Activation", "/psim/activation/pending"),
      getItem("Activation Report ", "/psim/activation/report"),
    ]),
    getItem("Inventory ","/sub74", <BookTwoTone />, [
      getItem("Manage", "/psim/inventory"),
      getItem("Report", "/psim/inventory/report"),
      getItem("Inventory Upload", "/psim/uploads/inventory"),
      getItem("Uploads","/sub75", <CloudTwoTone  />, [
        getItem("Product Type Upload", "/psim/uploads/product-types"),
        getItem("Product Plan Upload", "/psim/uploads/product-plans"),

      ]),

    ]),
  getItem("Usim-Mappings", "/sub81", <BuildTwoTone />, [
        getItem("Manage", "/psim/mappings/"),
        getItem("Upload", "/psim/mappings/upload")
      ]),
  ]),
  // distributor
  // getItem("Distributor", "/sub8", <EnvironmentTwoTone />, [
  //   getItem("Orders","/sub81", <EnvironmentTwoTone />, [
  //     getItem("New Orders", "/psim/distributor/new"),
  //     getItem("Manage Orders", "/psim/distributor/manage"),
  //   ])
  // ]),

  getItem("Webshop/App", "/sub5", <ShoppingTwoTone />, [
    // getItem("Manage Products", "/product-groups"),
    // getItem("Upload Products", "/product-groups/upload"),

    getItem("Webshop Products", "/webshop/products"),
    getItem("Promotions", "/sub51", <GiftOutlined/>, [
    getItem("Discounts", "/webshop/promotions"),
    getItem("Bundle Deals", "/webshop/bundles"),
    getItem("Deal Redemptions", "/webshop/redemptions"),
    getItem("Usage Triggered Offers", "/webshop/usage-triggered-offers"),
    ]),
    
    getItem("Razorpay Orders", "/webshop/orders"),
    getItem("Website Users", "/webshop/users"),
    getItem("Webshop Images (Beta)", "/webshop/assets"),
  ]),

  getItem("Distributor Portal", "/sub10", <ShopTwoTone />, [
    getItem("Distributors", "/distributor-portal"),
    getItem("eSIM Stock", "/distributor-portal/inventory"),
  ]),


  getItem("Archive", "/sub2", <EyeInvisibleTwoTone />, [
    {
      key: 'sub1-2',
      label: 'Joytel',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("Order Submit", "/jy-submit"),
        getItem("Order History", "/jy-history"),
        getItem("Redemption History", "/rd-history"),
        getItem("Manual Callback", "/manual-cb"),
        getItem("Update Mapping", "/u-mapping"),
      ],
    },
    {
      key: 'sub1-4',
      label: 'Slowboat',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("Order Submit", "/sb-submit"),
        getItem("Update Inventory", "/sb-mapping"),
        getItem("Inventory", "/sb-inventory"),
        getItem("Redemptions", "/sb-redemptions"),
      ]
    },
    {
      key: 'sub1-5',
      label: 'Mobifone',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("Order Submit", "/vn-submit"),
        getItem("Update Inventory", "/vn-mapping"),
        getItem("Inventory", "/vn-inventory"),
        getItem("Redemptions", "/vn-redemptions"),
      ]
    },
    {
      key: 'sub1-3',
      label: 'EliteMobile',
      icon: <ArrowRightOutlined />,
      children: [
        getItem("SIM Topup", "/em-recharge"),
        getItem("Top Up Report", "/em-recharge-history")
      ]
    },
  ]),
  getItem('User Settings', '/sub3', <ToolTwoTone />, [
    getItem("Account Management", "/user-settings/accounts"),
    getItem("Add New User", "/u-add"),
    getItem("Activity Log", "/u-history"),
  ]),

]

// submenu keys of first level
const rootSubmenuKeys = ["sub1", "sub2"];

export default function SideBar() {

    const [openKeys, setOpenKeys] = useState<string[]>([]);
    const [collapsed, setCollapsed] = useState(false);
    const [uname, setuname] = useState("")
    const [uprofile, setuprofile] = useState("")
    const [ditems, setditems] = useState<MenuItem[]>([]);
    const screens = useBreakpoint();

    const fetchData = async () => {
       let session = await Auth.currentUserInfo();
       console.log('User info Session', session.attributes.profile)
       setuname(session.username)
       setuprofile(session.attributes.profile)
       if (session.attributes.profile === 'user') {
        setditems(itemsUser);
      } else if (session.attributes.profile === 'admin') {
        setditems(items);
      } else {
        setditems(itemsUser);
      }
    }

    useEffect(() => {
     fetchData()
      }, []);

    const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
      const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
      if (rootSubmenuKeys.includes(latestOpenKey!)) {
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
      } else {
        setOpenKeys(keys);
      }
    };

    const toggleCollapsed = () => {
      setCollapsed(!collapsed);
    };

    return (
      <div
      style={{
        width: "fit-content",
        minWidth: "200px",
        maxWidth: "400px",
        height: "100%",
        // transition: "width 0.5s ease-in-out",
        overflow: "hidden",
      }}
    >

      <Menu
        mode="inline"
        defaultSelectedKeys={[]}
        defaultOpenKeys={[]}
        onOpenChange={onOpenChange}
        style={{
          height: "100%",
          borderRight: 0,
          whiteSpace: "normal",
          // position: "fixed",
          // width: "auto",
          // left: 0,
          // zIndex: 999,
          // top: 0,
          // paddingTop: 16,
          // maxHeight: "100vh",
        }}
        inlineCollapsed={screens.md ? false : true} // Collapse on small screens
        items={ditems}
      />
    </div>
    )

}
